import { Injectable } from '@angular/core';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  CalculateSubscriptionOptions,
} from '../../../../../../../../common/src/options/calculate-subscription.options';

@Injectable()
export class CreateSubscriptionFormFactory {
  constructor(private readonly formFactory: FormFactory) {

  }

  createCalculateSubscription(): AdvancedForm<CalculateSubscriptionOptions> {
    return this.formFactory.create(new CalculateSubscriptionOptions(), []);
  }
}
